// extracted by mini-css-extract-plugin
module.exports = {"cont":"testimonial-module--cont--1lFpP","textCont":"testimonial-module--textCont--1Tnmb","text":"testimonial-module--text--RxrLi","info":"testimonial-module--info--1tNBx"};